import { Button, useTranslation } from '@hbs-us/ui';
import { Link } from '@tanstack/react-router';
import { Users } from 'lucide-react';

/**
 * Empty-state card for the employees list (legacy `EmployeesPage` empty-state).
 * Copy switches on the archived filter AND on whether a text search is active (so a
 * no-match search reads "No matches" rather than "No employees yet"). The brand
 * `Users` glyph (UI-SPEC icon map) replaces the legacy bare table. The primary
 * "+ Add Employee" CTA (orange accent) links to the create route — shown only on the
 * active, unsearched empty state (UI-SPEC Color accent list).
 */
export function EmployeesEmptyState({
  showArchived,
  searching,
}: {
  showArchived: boolean;
  searching: boolean;
}) {
  const { t } = useTranslation();

  const headingKey = searching
    ? 'employees:empty.searchHeading'
    : showArchived
      ? 'employees:empty.archivedHeading'
      : 'employees:empty.heading';
  const bodyKey = searching
    ? 'employees:empty.searchBody'
    : showArchived
      ? 'employees:empty.archivedBody'
      : 'employees:empty.body';

  return (
    <div className="rounded-md border border-border bg-card p-12">
      <div className="flex flex-col items-center gap-4 text-center">
        <Users className="size-10 text-muted-foreground" aria-hidden="true" />
        <h2 className="font-display font-semibold text-foreground text-xl">{t(headingKey)}</h2>
        <p className="max-w-md text-muted-foreground text-sm">{t(bodyKey)}</p>
        {showArchived || searching ? null : (
          <Button asChild>
            <Link to="/employees/new">{t('employees:empty.cta')}</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
